// Verlanglijstje: hearts (snippets/wishlist-button.liquid), header count, and the list page
// (templates/collection.verlanglijstje.liquid). Items live in localStorage as
// {k: key, h: handle, v: variantId, p: 0|1 personalisable, q: {property: value} chosen personalisation or absent}.
(function () {
  var KEY = 'bt-wishlist';

  function hash(text) {
    var h = 5381;
    for (var i = 0; i < text.length; i++) h = ((h << 5) + h + text.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }
  function keyFor(handle, q) { return q ? handle + '#' + hash(JSON.stringify(q)) : handle; }
  function withKey(i) { if (!i.k) i.k = keyFor(i.h, i.q); return i; }
  function read() {
    try { var list = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(list) ? list.map(withKey) : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }

  // Small product cache so the list page shows instantly; refreshed in the background on every visit.
  var CACHE = 'bt-wishlist-cache';
  function readCache() { try { return JSON.parse(localStorage.getItem(CACHE) || '{}') || {}; } catch (e) { return {}; } }
  function slim(p) {
    return { handle: p.handle, title: p.title, featured_image: p.featured_image, variants: p.variants.map(function (v) {
      return { id: v.id, title: v.title, price: v.price, available: v.available, featured_image: v.featured_image ? { src: v.featured_image.src } : null };
    }) };
  }
  function cacheProduct(p) {
    var c = readCache();
    c[p.handle] = slim(p);
    var keep = {};
    read().forEach(function (i) { if (c[i.h]) keep[i.h] = c[i.h]; });
    if (!keep[p.handle]) keep[p.handle] = c[p.handle];
    try { localStorage.setItem(CACHE, JSON.stringify(keep)); } catch (e) {}
  }
  function fetchProduct(handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');
    return fetch(root + '/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cacheProduct(p); return p; })
      .catch(function () { return null; });
  }

  // Personalisable = the product page shows the "Ja, laat dit gratis personaliseren" checkbox.
  // Checked once per product via the product-form partial (small response) and remembered.
  var PKEY = 'bt-wishlist-p';
  function readP() { try { return JSON.parse(localStorage.getItem(PKEY) || '{}') || {}; } catch (e) { return {}; } }
  function rememberP(handle, value) {
    var map = readP();
    map[handle] = value ? 1 : 0;
    try { localStorage.setItem(PKEY, JSON.stringify(map)); } catch (e) {}
  }
  function detectP(handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');
    var url = location.origin + root + '/products/' + encodeURIComponent(handle);
    function check(html) {
      var text = typeof html === 'string' ? html : JSON.stringify(html);
      if (!text) throw new Error('empty');
      var value = text.indexOf('data-embroidery-skip') > -1;
      rememberP(handle, value);
      return value;
    }
    // Small partial response when available, otherwise the product page itself (only once per product).
    return import('@shopify/partial-rendering')
      .then(function (mod) { return mod.partials.fetch('product-form', { url: url }); })
      .then(check)
      .catch(function () {
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
          .then(check);
      })
      .catch(function () { return null; });
  }

  // Product page: the chosen personalisation (only when "Ja, laat dit gratis personaliseren" is ticked).
  function productForm() { return document.querySelector('s-product-form form'); }
  function personalising(form) {
    var toggle = form && form.querySelector('[data-embroidery-skip]');
    return !!(toggle && toggle.checked);
  }
  function currentProps(form) {
    if (!personalising(form)) return null;
    var q = {};
    var count = 0;
    new FormData(form).forEach(function (value, name) {
      if (typeof value !== 'string' || name.indexOf('properties[') !== 0) return;
      var label = name.slice(11, -1);
      value = value.trim();
      if (!label || label.charAt(0) === '_' || !value) return;
      q[label] = q[label] ? q[label] + ', ' + value : value;
      count++;
    });
    return count ? q : null;
  }
  function currentVariant(btn) {
    var field = document.querySelector('s-product-form form [name="id"]');
    return Number((field && field.value) || btn.dataset.variant) || null;
  }

  function sync() {
    var list = read();
    var form = productForm();
    var q = form ? currentProps(form) : null;
    var ticked = form ? personalising(form) : false;
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.dataset.handle;
      var pressed;
      if (btn.dataset.style === 'pdp') {
        pressed = list.some(function (i) { return i.k === keyFor(handle, q); });
        var show = pressed ? 'added' : (ticked ? 'add_p' : 'add');
        btn.querySelectorAll('[data-wl-label]').forEach(function (el) { el.hidden = el.dataset.wlLabel !== show; });
      } else {
        pressed = list.some(function (i) { return i.h === handle; });
      }
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? '' : 'none';
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var list = read();
    var handle = btn.dataset.handle;

    if (btn.dataset.style === 'pdp') {
      var form = productForm();
      // Ticked but a required choice is missing: the page's friendly "Je bent een stap vergeten" message points to it.
      if (form && personalising(form) && !form.checkValidity()) return;
      var q = form ? currentProps(form) : null;
      var k = keyFor(handle, q);
      if (list.some(function (i) { return i.k === k; })) {
        list = list.filter(function (i) { return i.k !== k; });
      } else {
        var p = document.querySelector('[data-embroidery-skip]') ? 1 : 0;
        rememberP(handle, p);
        var item = { k: k, h: handle, v: currentVariant(btn), p: p };
        if (q) item.q = q;
        list.push(item);
        fetchProduct(handle);
      }
      write(list);
      return;
    }

    if (list.some(function (i) { return i.h === handle; })) {
      list = list.filter(function (i) { return i.h !== handle; });
    } else {
      var known = readP()[handle];
      var cardP = known !== undefined ? known : (btn.dataset.p === '1' ? 1 : 0);
      list.push({ k: handle, h: handle, v: Number(btn.dataset.variant) || null, p: cardP });
      fetchProduct(handle);
      if (known === undefined) detectP(handle).then(function (value) {
        if (value === null) return;
        var current = read();
        current.forEach(function (i) { if (i.h === handle) i.p = value ? 1 : 0; });
        write(current);
      });
    }
    write(list);
  }, true);

  // Keep the product-page button label in step with the personalisation choices.
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('s-product-form')) sync(); });
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('s-product-form')) sync(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  window.addEventListener('pageshow', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  function init() {
    sync();
    var page = document.querySelector('[data-wishlist-page]');
    if (page) renderPage(page);
  }

  function encodeQ(q) {
    var bytes = new TextEncoder().encode(JSON.stringify(q));
    var bin = '';
    bytes.forEach(function (b) { bin += String.fromCharCode(b); });
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decodeQ(text) {
    try {
      var bin = atob(text.replace(/-/g, '+').replace(/_/g, '/'));
      var bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      var q = JSON.parse(new TextDecoder().decode(bytes));
      if (!q || typeof q !== 'object' || Array.isArray(q)) return null;
      var clean = {};
      Object.keys(q).slice(0, 20).forEach(function (key) { if (typeof q[key] === 'string') clean[String(key).slice(0, 80)] = q[key].slice(0, 200); });
      return Object.keys(clean).length ? clean : null;
    } catch (e) { return null; }
  }

  function renderPage(page) {
    var strings = JSON.parse((document.querySelector('[data-wishlist-strings]') || {}).textContent || '{}');
    var root = page.dataset.root || '';
    var money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: strings.currency || 'EUR' });
    function fmt(cents) { return money.format(cents / 100).replace(/\s/g, ''); }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function $(sel) { return page.querySelector(sel); }

    var params = new URLSearchParams(location.search);
    var sharedParam = params.get('lijst');
    var shared = !!sharedParam;
    var items = shared ? sharedParam.split(',').map(function (part) {
      var bits = part.split('~');
      var item = { h: bits[0], v: Number(bits[1]) || null, p: bits[2] === '1' ? 1 : 0 };
      var q = bits[3] ? decodeQ(bits[3]) : null;
      if (q) { item.q = q; item.p = 1; }
      return withKey(item);
    }).filter(function (i) { return /^[a-z0-9-]+$/i.test(i.h); }).slice(0, 40) : read();

    if (shared) {
      $('[data-wishlist-heading]').textContent = strings.sharedTitle;
      $('[data-wishlist-intro]').hidden = true;
      $('[data-wishlist-shared-note]').classList.remove('hidden');
      $('[data-wishlist-share]').classList.add('hidden');
      $('[data-wishlist-whatsapp]').classList.add('hidden');
      $('[data-wishlist-save-shared]').classList.remove('hidden');
    }

    var products = {};
    var listEl = $('[data-wishlist-list]');
    function byKey(k) { return items.find(function (i) { return i.k === k; }); }

    function chosenVariant(item) {
      var p = products[item.h];
      if (!p) return null;
      var v = p.variants.find(function (x) { return x.id === item.v; });
      return v || p.variants.find(function (x) { return x.available; }) || p.variants[0];
    }

    // With a chosen personalisation the item goes in with exactly those choices; otherwise "Zonder personalisatie".
    function lineFor(i) {
      var v = chosenVariant(i);
      if (!v || !v.available) return null;
      var line = { id: v.id, quantity: 1 };
      if (i.q) line.properties = Object.assign({}, i.q);
      else if (i.p) { line.properties = {}; line.properties[page.dataset.property] = page.dataset.propertyValue; }
      return line;
    }

    function render() {
      var live = items.filter(function (i) { return products[i.h]; });
      $('[data-wishlist-empty]').classList.toggle('hidden', live.length > 0);
      $('[data-wishlist-empty]').classList.toggle('flex', live.length === 0);
      $('[data-wishlist-actions]').classList.toggle('hidden', live.length === 0);
      $('[data-wishlist-actions]').classList.toggle('flex', live.length > 0);

      var total = 0;
      listEl.innerHTML = live.map(function (item) {
        var p = products[item.h];
        var v = chosenVariant(item);
        if (v && v.available) total += v.price;
        var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        var url = root + '/products/' + p.handle + (v ? '?variant=' + v.id : '');
        var key = esc(item.k);
        var select = '';
        if (p.variants.length > 1) {
          select = '<label class="flex flex-col gap-1 text-xs text-on-surface/70">' + esc(strings.variant) +
            '<select class="min-h-11 rounded-input border border-border bg-surface px-3 text-sm text-on-surface" data-wishlist-variant="' + key + '">' +
            p.variants.map(function (x) {
              return '<option value="' + x.id + '"' + (v && x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' (' + esc(strings.soldOut) + ')') + '</option>';
            }).join('') + '</select></label>';
        }
        var chosen = '';
        if (item.q) {
          chosen = '<div class="flex flex-col gap-1 rounded-input bg-surface/70 p-3 text-sm">' +
            '<span class="font-bold">' + esc(strings.chosenP) + '</span>' +
            '<dl class="m-0 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5">' +
            Object.keys(item.q).map(function (label) {
              return '<dt class="text-on-surface/70">' + esc(label) + '</dt><dd class="m-0 break-words font-medium">' + esc(item.q[label]) + '</dd>';
            }).join('') + '</dl></div>';
        }
        var buttons = '';
        if (v && v.available) {
          if (item.q) {
            buttons = '<button type="button" class="button-primary min-h-11 rounded-button px-4 text-sm font-bold" data-wishlist-add-one="' + key + '">' + esc(strings.addOne) + '</button>';
          } else if (item.p) {
            buttons = '<a href="' + esc(url + (url.indexOf('?') > -1 ? '&' : '?') + 'personaliseer=1') + '" class="button-primary inline-flex min-h-11 items-center rounded-button px-4 text-sm font-bold no-underline">' + esc(strings.withP) + '</a>' +
              '<button type="button" class="button-outline min-h-11 rounded-button px-4 text-sm font-bold" data-wishlist-add-one="' + key + '">' + esc(strings.withoutP) + '</button>';
          } else {
            buttons = '<button type="button" class="button-primary min-h-11 rounded-button px-4 text-sm font-bold" data-wishlist-add-one="' + key + '">' + esc(strings.addOne) + '</button>';
          }
        }
        return '<li class="flex gap-4 rounded-card bg-surface-secondary p-4">' +
          '<a href="' + esc(url) + '" class="block size-24 shrink-0 overflow-hidden rounded-input bg-white">' +
          (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" width="96" height="96" loading="lazy" class="size-full object-cover">' : '') + '</a>' +
          '<div class="flex min-w-0 flex-1 flex-col gap-2">' +
          '<a href="' + esc(url) + '" class="type-body-sm font-medium text-on-surface no-underline hover:underline line-clamp-2">' + esc(p.title) + '</a>' +
          '<span class="text-sm font-bold">' + (v ? (v.available ? fmt(v.price) : esc(strings.soldOut)) : '') + '</span>' +
          chosen + select +
          '<div class="flex flex-wrap items-center gap-2 pt-1 text-sm">' + buttons +
          (shared ? '' : '<button type="button" class="min-h-11 text-on-surface/70 underline underline-offset-2" data-wishlist-remove="' + key + '">' + esc(strings.remove) + '</button>') +
          '</div></div></li>';
      }).join('');
      $('[data-wishlist-total]').textContent = fmt(total);
      $('[data-wishlist-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(strings.shareText + ' ' + shareUrl());
    }

    function shareUrl() {
      var list = items.filter(function (i) { return products[i.h]; }).map(function (i) {
        var v = chosenVariant(i);
        return i.h + '~' + (v ? v.id : '') + '~' + (i.p ? 1 : 0) + (i.q ? '~' + encodeQ(i.q) : '');
      });
      return location.origin + location.pathname + '?view=verlanglijstje&lijst=' + encodeURIComponent(list.join(','));
    }

    function status(text) {
      var el = $('[data-wishlist-status]');
      el.textContent = text;
      el.classList.remove('hidden');
    }

    page.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-wishlist-variant]');
      if (!sel) return;
      var item = byKey(sel.dataset.wishlistVariant);
      if (item) item.v = Number(sel.value);
      if (!shared) write(items);
      render();
    });

    page.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wishlist-remove]');
      if (rm) {
        items = items.filter(function (i) { return i.k !== rm.dataset.wishlistRemove; });
        write(items);
        render();
        return;
      }
      if (e.target.closest('[data-wishlist-share]')) {
        var url = shareUrl();
        if (navigator.share) {
          navigator.share({ title: document.title, text: strings.shareText, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { status(strings.copied); });
        } else {
          window.prompt('', url);
        }
        return;
      }
      if (e.target.closest('[data-wishlist-save-shared]')) {
        var mine = read();
        items.forEach(function (i) { if (!mine.some(function (m) { return m.k === i.k; })) mine.push(i); });
        write(mine);
        status(strings.saved);
        return;
      }
      var addOne = e.target.closest('[data-wishlist-add-one]');
      if (addOne) {
        var one = byKey(addOne.dataset.wishlistAddOne);
        var oneLine = one && lineFor(one);
        if (!oneLine) return;
        addOne.disabled = true;
        addOne.textContent = strings.adding;
        $('[data-wishlist-error]').classList.add('hidden');
        fetch(page.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [oneLine] }) })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            addOne.textContent = strings.addedOne;
            // Refresh the header count and cart drawer right away (same route the product page uses).
            var Cart = window.customElements && customElements.get('s-cart');
            if (Cart && Cart.refreshMountedCarts) Cart.refreshMountedCarts().catch(function () {});
            status(strings.addedStatus);
          })
          .catch(function () { render(); $('[data-wishlist-error]').classList.remove('hidden'); });
        return;
      }
      var addAll = e.target.closest('[data-wishlist-add-all]');
      if (addAll) {
        var lines = items.filter(function (i) { return products[i.h]; }).map(lineFor).filter(Boolean);
        if (!lines.length) return;
        addAll.disabled = true;
        var addAllLabel = addAll.textContent;
        addAll.textContent = strings.adding;
        $('[data-wishlist-error]').classList.add('hidden');
        fetch(page.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); location.href = page.dataset.cartUrl; })
          .catch(function () { addAll.disabled = false; addAll.textContent = addAllLabel; $('[data-wishlist-error]').classList.remove('hidden'); });
      }
    });

    if (!items.length) { render(); return; }
    // Show cached products straight away, then update each one as soon as its fresh data arrives.
    var cached = readCache();
    items.forEach(function (i) { if (cached[i.h]) products[i.h] = cached[i.h]; });
    var frame = 0;
    function scheduleRender() { if (!frame) frame = requestAnimationFrame(function () { frame = 0; render(); }); }
    var handles = items.map(function (i) { return i.h; }).filter(function (h, n, all) { return all.indexOf(h) === n; });
    handles.forEach(function (h) {
      fetchProduct(h).then(function (p) {
        if (p) products[h] = slim(p);
        scheduleRender();
      });
    });
    // Use the remembered personalisation check, or look it up once (also fixes items saved before this check existed).
    var knownP = readP();
    handles.forEach(function (h) {
      var needs = items.filter(function (i) { return i.h === h && !i.q; });
      if (!needs.length) return;
      if (knownP[h] !== undefined) { needs.forEach(function (i) { i.p = knownP[h]; }); return; }
      detectP(h).then(function (value) {
        if (value === null) return;
        needs.forEach(function (i) { i.p = value ? 1 : 0; });
        if (!shared) {
          var mine = read();
          mine.forEach(function (m) { if (m.h === h && !m.q) m.p = value ? 1 : 0; });
          try { localStorage.setItem(KEY, JSON.stringify(mine)); } catch (e) {}
        }
        scheduleRender();
      });
    });
    if (Object.keys(products).length) render();
    else listEl.innerHTML = items.map(function () { return '<li class="h-32 rounded-card bg-surface-secondary motion-safe:animate-pulse" aria-hidden="true"></li>'; }).join('');
  }
})();
